import "./NFTab.css";

interface IProps {
    title: string;
    active?: boolean;
    onTabClick?: () => void;
}

export const NFSecondTab = ({ title, onTabClick, active }: IProps) => {
    return (
        <>
            <button
                onClick={onTabClick}
                className={`btn ${active === true ? "custom-btn-selected" : "custom-btn"}`}
            >
                {title}
            </button>
        </>
    );
};
